<!-- PAGE HEADER -->

<div class="page-header">
  <h2>Account Sign Up</h2>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<!-- FORM CARD -->
<div class="container">
  <form [formGroup]="signupForm" (ngSubmit)="submit()">

    <p class="required-note"><span>*</span> Required</p>

    <!-- ================= BUSINESS INFORMATION ================= -->
    <section formGroupName="businessInfo">
      <h3>Business Information</h3>

      <div class="row">
        <div class="field" [ngClass]="displayFieldCss('businessInfo.businessName')">
          <label><span>* </span>Business/Organization Name</label>
          <input type="text" formControlName="businessName" maxlength="100" autofocus>
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'businessInfo.businessName':ValidationPatterns.ALLOWED_BUSINESS_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field" [ngClass]="displayFieldCss('businessInfo.industry')">
          <label><span>* </span>Industry</label>

          <select #industrySelect formControlName="industry" (change)="onIndustryChange(industrySelect.value)">
            <option value="">Select</option>
            <option *ngFor="let industry of industryList" [value]="industry.industryPk">
              {{ industry.industryName }}
            </option>
          </select>

          <!-- New input below dropdown -->
          <input *ngIf="isIndustryOther" type="text" formControlName="otherIndustry" maxlength="100" />

          <div class="error-message"
            *ngIf="signupForm | invalidChars:'businessInfo.otherIndustry':ValidationPatterns.ALLOWED_BUSINESS_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field">
          <label>Entity Type</label>

          <select #entityTypeSelect formControlName="entityType" (change)="onEntityTypeChange(entityTypeSelect.value)">
            <option value="">Select</option>
            <option *ngFor="let entityType of entityTypeList" [value]="entityType.entityTypePk">
              {{ entityType.entityTypeName }}
            </option>
          </select>

          <input *ngIf="isEntityTypeOther" type="text" formControlName="otherEntityType" maxlength="100" />

          <div class="error-message"
            *ngIf="signupForm | invalidChars:'businessInfo.otherEntityType':ValidationPatterns.ALLOWED_BUSINESS_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>



        <div class="field">
          <label>Number of Employees</label>
          <input type="text" formControlName="employees" inputmode="numeric" maxlength="6" (input)="onInput($event)" />

        </div>

      </div>

      <!-- Address row -->
      <div class="row address-row">
        <div class="field" [ngClass]="displayFieldCss('businessInfo.address1')">
          <label><span>* </span>Address</label>
        
          <app-google-place-autocomplete [formGroup]="businessInfoForm" address1ControlName="address1" cityControlName="city"
            stateControlName="state" zipCodeControlName="zip" [maxlength]="60">
          </app-google-place-autocomplete>
        
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'businessInfo.address1':ValidationPatterns.ALLOWED_ADDRESS_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field">
          <label>Address 2</label>
          <input type="text" formControlName="address2" maxlength="60">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'businessInfo.address2':ValidationPatterns.ALLOWED_ADDRESS_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field" [ngClass]="displayFieldCss('businessInfo.city')">
          <label><span>* </span>City</label>
          <input type="text" formControlName="city" id="city" maxlength="30">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'businessInfo.city':ValidationPatterns.ALLOWED_CITY_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field" [ngClass]="displayFieldCss('businessInfo.state')">
          <label><span>* </span>State</label>
          <select formControlName="state" id="state">
            <option value="">Select</option>
            <option *ngFor="let state of stateList" [value]="state.stateCode">
              {{ state.stateName }}
            </option>
          </select>
        </div>

        <div class="field" [ngClass]="displayFieldCss('businessInfo.zip')">
          <label><span>* </span>Zip Code</label>
          <input type="tel" formControlName="zip" minlength="5" maxlength="10" inputmode="numeric"
            placeholder="XXXXX-XXXX" mask="00000-9999" [validation]="true" [dropSpecialCharacters]="true">
        </div>
      </div>

      <div class="row">
        <div class="field" [ngClass]="displayFieldCss('businessInfo.phone')">
          <label><span>* </span>Business Phone </label>
          <input type="text" formControlName="phone" maxlength="15" inputmode="numeric" placeholder="(XXX) XXX-XXXX"
            mask="(000) 000-0000" [validation]="true" [dropSpecialCharacters]="true">

        </div>
        <div class="field">
          <label>Business Fax </label>
          <input type="text" formControlName="companyFax" maxlength="15" inputmode="numeric"
            placeholder="(XXX) XXX-XXXX" mask="(000) 000-0000" [validation]="true" [dropSpecialCharacters]="true">

        </div>


        <div class="field" [ngClass]="displayFieldCss('businessInfo.email')">
          <label><span>* </span>Business Email</label>
          <input type="email" formControlName="email" maxlength="100"
            pattern="^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'businessInfo.email':ValidationPatterns.ALLOWED_EMAIL_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field" [ngClass]="displayFieldCss('businessInfo.taxExempt')">
          <label><span>* </span>Is your business tax exempt?</label>
          <select #taxExemptSelect formControlName="taxExempt">
            <option value="">Select</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
        <div class="field" [ngClass]="displayFieldCss('businessInfo.employerIdentificationNumber')">
          <label>Employer Identification Number (EIN)</label>
          <input type="text" formControlName="employerIdentificationNumber" maxlength="10" inputmode="numeric"
            placeholder="XX-XXXXXXX" mask="00-0000000" [validation]="true" [dropSpecialCharacters]="true">
        </div>
      </div>
    </section>

    <!-- ================= PRIMARY CONTACT ================= -->
    <section formGroupName="primaryContact">
      <h3>Primary Contact Information</h3>

      <!-- Prefix + Name + Suffix + Job Title -->
      <div class="row name-job-row">
        <div class="field">
          <label>Prefix</label>
          <select formControlName="prefix">
            <option value="">Select</option>
            <option *ngFor="let prefix of prefixList" [value]="prefix.prefixPk">
              {{ prefix.prefix }}
            </option>
          </select>
        </div>

        <div class="field" [ngClass]="displayFieldCss('primaryContact.firstName')">
          <label><span>* </span>First Name </label>
          <input type="text" formControlName="firstName" maxlength="100">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'primaryContact.firstName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field" [ngClass]="displayFieldCss('primaryContact.lastName')">
          <label><span>* </span>Last Name</label>
          <input type="text" formControlName="lastName" maxlength="100">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'primaryContact.lastName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field">
          <label>Suffix</label>
          <select formControlName="suffix">
            <option value="">Select</option>
            <option *ngFor="let suffix of suffixList" [value]="suffix.suffixPk">
              {{ suffix.suffix }}
            </option>
          </select>
        </div>

        <div class="field">
          <label>Job Title</label>
          <input type="text" formControlName="jobTitle" maxlength="100">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'primaryContact.jobTitle':ValidationPatterns.ALLOWED_JOB_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="ext-fax-group">
          <div class="field fax-field" [ngClass]="displayFieldCss('primaryContact.primaryphone')">
            <label><span>* </span>Phone </label>
            <input type="text" formControlName="primaryphone" mask="(000) 000-0000" [dropSpecialCharacters]="true"
              placeholder="(XXX) XXX-XXXX" />
          </div>
          <div class="field ext-field">
            <label>Ext</label>
            <input type="text" inputmode="numeric" formControlName="primaryphoneExt" maxlength="10"
              (input)="allowNumbersOnly($event, 'primaryContact.primaryphoneExt')" />
          </div>
        </div>

        <div class="field">
          <label>Fax</label>
          <input type="text" formControlName="fax" mask="(000) 000-0000" [dropSpecialCharacters]="true"
            placeholder="(XXX) XXX-XXXX" />
        </div>


        <div class="field" [ngClass]="displayFieldCss('primaryContact.email')">
          <label><span>* </span>Email</label>
          <input type="email" formControlName="email" maxlength="100"
            pattern="^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$" />
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'primaryContact.email':ValidationPatterns.ALLOWED_EMAIL_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>
      </div>

    </section>

    <!-- ================= SECONDARY CONTACT ================= -->
    <section formGroupName="secondaryContact">
      <h3>Secondary Contact Information</h3>

      <div class="row name-job-row">
        <div class="field">
          <label>Prefix</label>
          <select formControlName="prefix">
            <option value="">Select</option>
            <option *ngFor="let prefix of prefixList" [value]="prefix.prefixPk">
              {{ prefix.prefix }}
            </option>
          </select>
        </div>

        <div class="field">
          <label>First Name</label>
          <input type="text" formControlName="firstName" maxlength="100">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'secondaryContact.firstName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field">
          <label>Last Name</label>
          <input type="text" formControlName="lastName" maxlength="100">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'secondaryContact.lastName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>

        <div class="field">
          <label>Suffix</label>
          <select formControlName="suffix">
            <option value="">Select</option>
            <option *ngFor="let suffix of suffixList" [value]="suffix.suffixPk">
              {{ suffix.suffix }}
            </option>
          </select>
        </div>

        <div class="field">
          <label>Job Title</label>
          <input type="text" formControlName="jobTitle" maxlength="100">
          <div class="error-message"
            *ngIf="signupForm | invalidChars:'secondaryContact.jobTitle':ValidationPatterns.ALLOWED_JOB_CHARS as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="ext-fax-group">
          <div class="field fax-field">
            <label>Phone</label>
            <input type="text" formControlName="secondaryphone" mask="(999) 999-9999" [dropSpecialCharacters]="true"
              placeholder="(XXX) XXX-XXXX" />
          </div>

          <div class="field ext-field">
            <label>Ext</label>
            <input type="text" inputmode="numeric" formControlName="secondaryphoneExt" maxlength="10"
              (input)="allowNumbersOnly($event, 'primaryContact.secondaryphoneExt')" />
          </div>
        </div>
        <div class="field">
          <label>Fax</label>
          <input type="text" formControlName="secondaryFax" mask="(999) 999-9999" [dropSpecialCharacters]="true"
            placeholder="(XXX) XXX-XXXX" />
        </div>

        <div class="field" [ngClass]="{
       'has-error':
       signupForm.get('secondaryContact.secondaryEmail')?.invalid &&
       signupForm.get('secondaryContact.secondaryEmail')?.touched
     }">

          <label>Email</label>

          <input type="email" formControlName="secondaryEmail" maxlength="100"
            pattern="^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$" />

          <!-- <div class="error-message" *ngIf="getEmailInvalidChars('secondaryContact.secondaryEmail') as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div> -->

          <!-- Required -->
          <div class="error-message" *ngIf="signupForm.get('secondaryContact.secondaryEmail')?.hasError('required')
              && signupForm.get('secondaryContact.secondaryEmail')?.touched">
            Email is required.
          </div>

          <div class="error-message"
            *ngIf="signupForm.get('secondaryContact.secondaryEmail')?.touched
            && (signupForm | invalidChars:'secondaryContact.secondaryEmail':ValidationPatterns.ALLOWED_EMAIL_CHARS) as invalidChars">
            Invalid chars: {{ invalidChars }}
          </div>
          <!-- Format -->
          <!-- <div class="error-message" *ngIf="signupForm.get('secondaryContact.secondaryEmail')?.hasError('email')
              && signupForm.get('secondaryContact.secondaryEmail')?.touched">
            Please enter a valid email.
          </div> -->

          <!-- Email Match -->
          <div class="error-message" *ngIf="signupForm.get('secondaryContact.secondaryEmail')?.hasError('emailMatch')
              && signupForm.get('secondaryContact.secondaryEmail')?.touched">
            Primary and Secondary email cannot be the same.
          </div>

        </div>

      </div>

    </section>
    <div id="recaptcha-container"></div>

    <div *ngIf="signupForm.get('captcha')?.invalid && signupForm.get('captcha')?.touched" class="captcha-error">
      Please complete the CAPTCHA verification.
    </div>

    <div class="actions mt-30">
      <button type="button" (click)="cancel()">Cancel</button>
      <button type="submit">Submit</button>
    </div>

  </form>
</div>
<p-dialog header="{{ dialogSummary }}"
  [styleClass]="dialogSummary === 'Account Created' ? 'success-dialog' : 'p-dialog'" [(visible)]="locListModalDlg"
  [closable]="false" [closeOnEscape]="false" [modal]="true" [dismissableMask]="false" [style]="{ width: '580px' }"
  [breakpoints]="{ '640px': '95vw' }">

  <div class="dialog-body" [innerHTML]="dialogMsg"></div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button type="button" class="button-primary" (click)="okClickedV2()">
        Ok
      </button>
    </div>
  </ng-template>

</p-dialog>